// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"96db57aa","551":"3a292993","842":"9cdccd46"}[chunkId] + ".chunk.js";
};